var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCfDoneShieldA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 57.6108,
    height: 64.1125,
    viewBox: "0 0 57.6108 64.1125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.8054 64.1125L27.6554 63.825C-2.53209 51.4625 0.0554135 12.3625 0.0554135 11.7875L0.342913 9.2H2.93041C16.1554 9.2 27.0804 1.15 27.0804 1.15L28.8054 0L30.5304 1.15C30.5304 1.15 41.4554 9.2 54.6804 9.2H57.2679L57.5554 11.7875C57.5554 12.075 60.1429 51.4625 29.9554 63.5375L28.8054 64.1125ZM5.80541 14.95C5.80541 23 7.53041 48.5875 28.8054 58.075C50.0804 48.875 51.8054 23.2875 51.8054 14.95C41.1679 14.0875 32.2554 9.2 28.8054 6.9C25.3554 9.2 16.4429 14.0875 5.80541 14.95Z",
    fill: "url(#paint0_linear_0_12)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_12",
    x1: 7.45998e-8,
    y1: 32.0563,
    x2: 47.3683,
    y2: 32.2302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB29"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfDoneShieldA);
export default __webpack_public_path__ + "static/media/cf-done-shield-a.8482edff69b9cb7d2d476322f2a1943c.svg";
export { ForwardRef as ReactComponent };